var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('span',[_vm._v(" "+_vm._s(_vm.data.item.name))]),(_vm.data.item.email)?_c('span',{staticClass:"text-muted"},[_vm._v(" - "+_vm._s(_vm.data.item.email))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }